import React, { useEffect, useMemo, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

import MenuItem from '@mui/material/MenuItem';
import { Link } from 'react-router-dom';
import { GetSettingBySettingName } from 'services/UsersService';

interface Props {
  open: boolean;
  clientId?: number;
  contactId?: number;
  closeHandler: () => void;
}

const validOpportunityTypes = [1, 2, 4, 5, 6];

export default function CreateOpportunityHandlerDialog({
  open,
  clientId,
  contactId,
  closeHandler,
}: Props) {
  const [defaultType, setDefaultType] = useState(5);
  const [opportunityType, setOpporunityType] = useState(5);

  useEffect(() => {
    const getDefaultSetting = async () => {
      const res = await GetSettingBySettingName('DefaultOpportunityType');
      if (res && validOpportunityTypes.includes(+res)) setDefaultType(+res);
    };
    open && getDefaultSetting();
  }, [open]);

  useEffect(() => {
    if (open) {
      setOpporunityType(defaultType);
    }
  }, [open, defaultType]);

  const createPath = useMemo(() => {
    let sourceParams = '';
    if (clientId) sourceParams = `&ClientID=${clientId}`;
    if (contactId) sourceParams += `&ContactID=${contactId}`;
    return `/opportunities/create?type=${opportunityType}` + sourceParams;
  }, [clientId, contactId, opportunityType]);

  return (
    <>
      <Dialog open={open} fullWidth>
        <DialogTitle>Create Opportunity</DialogTitle>
        <DialogContent>
          <Stack mt="10px" spacing={2}>
            <TextField
              select
              value={opportunityType}
              label="Type"
              onChange={({ target }) => setOpporunityType(+target.value)}
            >
              <MenuItem value="1">Back Fill</MenuItem>
              <MenuItem value="4">Bid</MenuItem>
              <MenuItem value="5">General</MenuItem>
              <MenuItem value="6">Lead</MenuItem>
              <MenuItem value="2">Tender</MenuItem>
            </TextField>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="error" onClick={closeHandler}>
            Cancel
          </Button>
          <Link to={createPath} style={{ marginLeft: '.5rem' }}>
            <Button variant="contained" color="success" onClick={closeHandler}>
              Submit
            </Button>
          </Link>
        </DialogActions>
      </Dialog>
    </>
  );
}
